import React, { Component } from "react";
import { Space } from "antd";
import { DownOutlined, RightOutlined } from "@ant-design/icons";
import { ModalItem, ButtonItem, InputNumberItem, round2Decimals, MensajeError } from "../../../../Components/Items";
import { iconoDeEtapa, colorDeEtapa } from "../EtapasOrdenProduccionPU/etapaVisual.utils";

const SIN_MATRIZ = "__sin_matriz__";

const renderEtapaTag = (etapa) => {
  if (!etapa) return null;
  const color = colorDeEtapa(etapa);
  return (
    <span
      style={{
        display: "inline-flex",
        alignItems: "center",
        gap: 4,
        border: `1.5px solid ${color}`,
        backgroundColor: "#fff",
        borderRadius: 999,
        padding: "0 8px",
        height: 22,
        lineHeight: "19px",
        fontSize: 12,
        color: "#000",
      }}
    >
      <span style={{ color, display: "flex" }}>{iconoDeEtapa(etapa)}</span>
      {etapa.nombre}
    </span>
  );
};

class ModalSobrantesCierreOrdenPU extends Component {
  state = { cantidades: {}, colapsados: [] };

  componentDidUpdate(prevProps) {
    if (this.props.visible && !prevProps.visible) {
      const cantidades = {};
      (this.props.sobrantes || []).forEach((s) => {
        cantidades[s.insumoId] = Math.max(0, s.inventarioSupuesto || 0);
      });
      this.setState({ cantidades, colapsados: [] });
    }
  }

  cambiarCantidad = (insumoId, cantidad) =>
    this.setState((prev) => ({ cantidades: { ...prev.cantidades, [insumoId]: cantidad } }));

  onToggleGrupo = (grupoId) =>
    this.setState((prev) => ({
      colapsados: prev.colapsados.includes(grupoId) ? prev.colapsados.filter((id) => id !== grupoId) : [...prev.colapsados, grupoId],
    }));

  grupos = () => {
    const { sobrantes = [] } = this.props;
    const grupos = new Map();
    sobrantes.forEach((s) => {
      const grupoId = s.matrizId || SIN_MATRIZ;
      if (!grupos.has(grupoId)) {
        grupos.set(grupoId, {
          grupoId,
          clave: s.matrizId ? s.matrizClave : "",
          descripcion: s.matrizId ? s.matrizDescripcion : "Insumos fuera de lista",
          etapa: s.matrizId ? s.etapa : null,
          insumos: [],
        });
      }
      grupos.get(grupoId).insumos.push(s);
    });

    return [...grupos.values()].sort((a, b) => {
      if (a.grupoId === SIN_MATRIZ) return 1;
      if (b.grupoId === SIN_MATRIZ) return -1;
      if (a.etapa && b.etapa) return (a.etapa.orden || 0) - (b.etapa.orden || 0);
      if (a.etapa) return -1;
      if (b.etapa) return 1;
      return 0;
    });
  };

  onConfirmar = () => {
    const { sobrantes = [] } = this.props;
    const { cantidades } = this.state;

    const invalido = sobrantes.some((s) => cantidades[s.insumoId] == null || cantidades[s.insumoId] < 0);
    if (invalido) {
      MensajeError({ message: "Captura la cantidad real (puede ser 0) para cada insumo antes de cerrar la orden" });
      return;
    }

    const sobrantesReales = sobrantes.map((s) => ({ insumoId: s.insumoId, cantidad: cantidades[s.insumoId] }));
    this.props.onConfirmar(sobrantesReales);
  };

  render() {
    const { visible, onCerrar } = this.props;
    const { cantidades, colapsados } = this.state;
    const grupos = this.grupos();

    return (
      <ModalItem
        title="Sobró material en esta orden"
        visible={visible}
        spinning={false}
        onCancel={onCerrar}
        width="70%"
        paddingTop
        footer={null}
      >
        <div style={{ color: "#999", fontSize: 12, marginBottom: 14 }}>
          <b>Planeado</b> es lo que el BOM dice que se necesitaba en total (no aplica a insumos fuera de lista). <b>Inventario
          supuesto</b> es lo que el sistema cree que sobra (traspasado menos consumido registrado). Captura la cantidad que{" "}
          <b>realmente</b> sobró de cada insumo -- si difiere, se usa lo que captures aquí (0 si no sobró nada). Lo que quede como
          sobrante se registra en Almacén, etiquetado como "sobrante de esta orden".
        </div>

        <div style={{ overflowX: "auto" }}>
          <table className="table" style={{ borderCollapse: "separate", borderSpacing: 0 }}>
            <thead>
              <tr>
                <th className="th-border">Insumo</th>
                <th className="th-border" style={{ textAlign: "right", width: "11%" }}>
                  Planeado
                </th>
                <th className="th-border" style={{ textAlign: "right", width: "11%" }}>
                  Ya requisitado
                </th>
                <th className="th-border" style={{ textAlign: "right", width: "11%" }}>
                  Traspasado
                </th>
                <th className="th-border" style={{ textAlign: "right", width: "11%" }}>
                  Consumido
                </th>
                <th className="th-border" style={{ textAlign: "right", width: "14%" }}>
                  Inventario supuesto
                </th>
                <th className="th-border" style={{ textAlign: "right", width: "18%" }}>
                  Cantidad que realmente sobró
                </th>
              </tr>
            </thead>
            {grupos.map((grupo) => {
              const colapsado = colapsados.includes(grupo.grupoId);
              const acento = grupo.etapa ? colorDeEtapa(grupo.etapa) : "#999";
              return (
                <tbody key={grupo.grupoId}>
                  <tr>
                    <td
                      colSpan={7}
                      style={{ borderLeft: `4px solid ${acento}`, padding: "8px 12px", background: "#fafafa", cursor: "pointer" }}
                      onClick={() => this.onToggleGrupo(grupo.grupoId)}
                    >
                      <Space size={10}>
                        {colapsado ? <RightOutlined style={{ fontSize: 11, color: "#999" }} /> : <DownOutlined style={{ fontSize: 11, color: "#999" }} />}
                        <span style={{ fontWeight: 700, color: "#333" }}>
                          {grupo.clave ? grupo.clave + " - " : ""}
                          {grupo.descripcion}
                        </span>
                        {renderEtapaTag(grupo.etapa)}
                      </Space>
                    </td>
                  </tr>
                  {!colapsado &&
                    grupo.insumos.map((s) => (
                      <tr key={s.insumoId}>
                        <td className="td-border">
                          {s.clave ? s.clave + " - " : ""}
                          {s.descripcion}
                        </td>
                        <td className="td-border" style={{ textAlign: "right" }}>
                          {s.planeado ?? "—"}
                        </td>
                        <td className="td-border" style={{ textAlign: "right" }}>
                          {s.yaRequisitado ?? "—"}
                        </td>
                        <td className="td-border" style={{ textAlign: "right" }}>
                          {s.traspasado} {s.unidad}
                        </td>
                        <td className="td-border" style={{ textAlign: "right" }}>
                          {s.consumido} {s.unidad}
                        </td>
                        <td className="td-border" style={{ textAlign: "right", fontWeight: 600 }}>
                          {s.inventarioSupuesto} {s.unidad}
                        </td>
                        <td className="td-border" style={{ textAlign: "right" }}>
                          <InputNumberItem
                            size="small"
                            style={{ width: 120 }}
                            min={0}
                            value={cantidades[s.insumoId]}
                            onChange={(valor) => this.cambiarCantidad(s.insumoId, round2Decimals(valor || 0))}
                          />
                        </td>
                      </tr>
                    ))}
                </tbody>
              );
            })}
          </table>
        </div>

        <div style={{ textAlign: "right", marginTop: 16 }}>
          <ButtonItem style={{ marginRight: 8 }} onClick={onCerrar}>
            Cancelar
          </ButtonItem>
          <ButtonItem type="primary" lima onClick={this.onConfirmar}>
            Confirmar y cerrar orden
          </ButtonItem>
        </div>
      </ModalItem>
    );
  }
}

export default ModalSobrantesCierreOrdenPU;
